module.exports = __webpack_public_path__ + "static/img/star3.2ddf9f8e.png";